import React from 'react';
import AdContainer from './AdContainer';

const BannerAd = (props) => (
    <AdContainer
        className="ad-slot-banner ad-wrapper"
        kvps={{ pos: 'banner' }}
        slotType="banner"
        refreshOnLoad={props.refreshOnLoad}
    />
);

BannerAd.defaultProps = {
    refreshOnLoad: false
};

BannerAd.propTypes = {
    refreshOnLoad: React.PropTypes.bool
};

export default BannerAd;



// WEBPACK FOOTER //
// ./app/ads/BannerAd.js